<template>
  <BigNumberParent>
    <div
      :style="
        `position: absolute; height: ${sparklineHeight}px; width: ${sparklineWidth}px; bottom: 0;`
      "
    >
      <div class="sparklineTooltip" ref="sparklineTooltip"></div>
      <BigNumberFaelleBars
        :sparkline="austria_timeline"
        :sparkline_keys="['bestätigte_Fälle_tag_diff']"
        :colors="colors"
        :mobile="mobile"
        format=",d"
        :styles="{
          width: `${sparklineWidth}px`,
          height: `${sparklineHeight}px`,
          position: 'absolute',
          bottom: 0
        }"
        v-if="sparklineHeight && sparklineWidth"
      >
      </BigNumberFaelleBars>
    </div>
    <div class="flex-row" ref="chartcontainer">
      <div class="flex-left">
        <div class="dg-value" :style="{ color: this.colors.infizierte }">
          <span style="display: inline-block">
            <span v-html="`${$fmt(',d')(this.heute)}`"></span>
          </span>
        </div>
        <h6>bestätigte Fälle</h6>
      </div>
    </div>
    <div class="outlier-right">
      <h6 v-if="!selected_xvalue">
        Meldungen
      </h6>
      <h6 v-if="selected_xvalue" :style="{ fontSize: '12px' }">
        Testergebnisse
      </h6>
      <h6>
        {{ !selected_xvalue ? "seit gestern" : datefmt(selected_xvalue) }}
      </h6>
      <div>
        <span class="dg-value2" :style="{ color: this.colors.infizierte }">{{
          $fmt("+,d")(+selectedValue)
        }}</span>
      </div>
    </div>
  </BigNumberParent>
</template>
<script>
import BigNumberFaelleBars from "./BigNumberFaelleBars";
import ComponentSizeMixin from "./ComponentSizeMixin";
import BigNumberParent from "./BigNumberParent.vue";
import moment from "moment";

export default {
  name: "BigNumberFaelle",
  components: {
    BigNumberParent,
    BigNumberFaelleBars
  },
  mixins: [ComponentSizeMixin],
  props: {
    austria_timeline: Array,
    austria_latest: Object,
    colors: Object,
    sparkline: Array,
    sparkline_keys: Array,
    mobile: String,
    format: {
      type: String,
      default: ",.0f"
    },
    bestaetigte_faelle_summe_aenderung: Array
  },
  data: () => ({
    selected_xvalue: null
  }),
  computed: {
    sparklineWidth() {
      if (!this.chartcontainerHeight) {
        return null;
      }
      return this.chartcontainerWidth - 70;
    },
    sparklineHeight() {
      return Math.max(this.chartcontainerHeight - 40, 90);
    },
    selectedValue() {
      return this.selected_xvalue
        ? this.austria_timeline.filter(d => d.date == this.selected_xvalue)[0]
            .bestätigte_Fälle_tag_diff
        : +this.diff;
    },
    diff() {
      return this.bestaetigte_faelle_summe_aenderung.filter(
        d => d.bezcode == "000"
      )[0].diff;
    },
    heute() {
      return this.bestaetigte_faelle_summe_aenderung.filter(
        d => d.bezcode == "000"
      )[0].heute;
    }
  },
  methods: {
    select_xvalue(xvalue) {
      this.selected_xvalue = xvalue;
    },
    datefmt(x) {
      return moment(x).format("D. MMMM");
    }
  },
  provide() {
    return {
      setTooltipXValue: function(xvalue) {
        this.select_xvalue(xvalue);
      }.bind(this)
    };
  }
};
</script>

<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: top;
  height: 100%;
  position: relative;
  pointer-events: none;
  padding-bottom: 40px;
}

.flex-left {
  text-align: left;
  line-height: 1em;
}

.flex-row >>> .sparkline-wrap {
  display: inline-block;
  width: 33%;
  text-align: right;
}

.outlier-right {
  position: absolute;
  right: 6px;
  top: 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: right;
  justify-content: center;
  pointer-events: none;
}
.flex-right h6 {
  text-align: right;
  font-size: 12px;
  line-height: 1em;
}

.dg-value {
  font-size: 26px;
  font-weight: bold;
  line-height: 1em;
  display: flex;
  width: 100%;
  flex-direction: row;
}

.dg-value2 {
  font-size: 20px;
  font-weight: bold;
  line-height: 0.6em;
  display: inline-block;
  padding-bottom: 0.3em;
  padding-top: 0.3em;
}

.diff {
  font-size: 14px;
  padding-top: 4px;
  line-height: 1em;
  display: block;
  min-height: 1em;
}

.dg-number,
h6 {
  display: block;
}

.dg-number {
  text-align: right;
  padding-right: 3px;
}

.dg-number2 {
  text-align: left;
  align-items: flex-end;
  display: block;
}

.dg-number2 span {
  display: inline-block;
  width: 48px;
  text-align: right;
}

h6 {
  text-align: left;
  padding-left: 3px;
  font-weight: normal;
}

.dg-value.value2 {
  font-size: 16px;
}

.dg-value.value2 .davon {
  font-size: 10px;
  font-weight: normal;
}
.dg-value.value2 .spacer {
  display: inline-block;
  width: 30px;
}

@media (min-width: 700px) {
  .cmc_normal .dg-value {
    font-size: 32px;
  }
  .outlier-right {
    top: 0.7em;
    right: 0.7em;
  }
}

@media (min-width: 900px) {
  .cmc_normal .dg-value {
    font-size: 36px;
  }
  .cmc_normal .dg-value2 {
    font-size: 22px;
  }

  .outlier-right {
    top: 1.1em;
    right: 1.1em;
  }
}

h6 {
  font-size: 14px;
  margin: 0;
  display: block;
  color: white;
  vertical-align: bottom;
}

h6.small {
  font-size: 12px;
  font-weight: normal;
  color: white;
  padding-left: 4px;
  vertical-align: bottom;
  margin-bottom: -1px;
}

span {
  vertical-align: bottom;
}

span.einheit >>> small {
  font-size: 75%;
}
.sparklineTooltip {
  font-size: 10px;
  right: 0;
  bottom: 0;
  position: absolute;
}
</style>
